import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enText from './en-US'
import zhText from './zh-CN'

const microData = (window as any).microApp?.getData() || { }

const lng = microData.locale || 'zh'
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enText,
      },
      zh: {
        translation: zhText,
      },
    },
    lng: lng,
    fallbackLng: lng,

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
